
const Items =  [
  {
    'kode': 'E14160071',
    'nama': 'CV Tani Indah Lestari',
    'narahubung': 'Sari Prihartini',
    'phone': '082309878976',
    'status': "Ya",
    'alamat': {
      'street': 'Jalan Cempaka 45, Ciamis, Jabar 16675',
    },
    'website' : "www.indahtanilestari.com ",
    'unitUsaha' : "Grower",
  },
  {
    'kode': 'G84150073',
    'nama': 'CV Mitra Sejahtera',
    'narahubung': 'Budi Gunawan',
    'phone': '089675432675',
    'status': "Tidak",
    'alamat': {
      'street': 'Jalan Babakan 32, Dramaga, Bogor, Jabar 16680',
    },
    'website' : "www.mitrasejahtera.com",
    'unitUsaha' : "Broker ",
  },
  {
    'kode': 'A24260056',
    'nama': 'PT Agung Tani Jaya',
    'narahubung': 'Supriono',
    'phone': '081234567985',
    'status': "Ya",
    'alamat': {
      'street': 'Jalan Lembayung 67, Semarang, Jateng 563425',
    },
    'website' : "www.agungtanijaya.co.id",
    'unitUsaha' : "Logistic",
  },
  {
    'kode': 'F24150004',
    'nama': 'PT Sumber Pangan',
    'narahubung': 'Ade Chandra',
    'phone': '082365478239',
    'status': "Ya",
    'alamat': {
      'street': 'Jalan Alternatif Ponorogo 34, Ponorogo, Jatim 765324',
    },
    'website' : "-",
    'unitUsaha' : "Logistic",
  },
  {
    'kode': 'H14160065',
    'nama': 'CV Rimba Lestari',
    'narahubung': 'Adung',
    'phone': '081345672398',
    'status': "Tidak",
    'alamat': {
      'street': 'Jalan Cengal 105, Leuwiliang, Bogor, Jabar 16690',
    },
    'website' : "-",
    'unitUsaha' : "Grower",
  },
  {
    'kode': 'G64150076',
    'nama': 'PT Kayu Kencana Wangi',
    'narahubung': 'Mulia',
    'phone': '086543762698',
    'status': "Ya",
    'alamat': {
      'street': 'Jalan Kayuringin 62, Kuningan, Jabar 765423',
    },
    'website' : "www.kayukencanawangi.com",
    'unitUsaha' : "Broker",
  },
  {
    'kode': 'C34170098',
    'nama': 'CV Tani Prima',
    'narahubung': 'Linda Safira',
    'phone': '081278653489',
    'status': "Ya",
    'alamat': {
      'street': 'Jalan Sudirman 45, Cianjur, Jabar 145278',
    },
    'website' : "-",
    'unitUsaha' : "Grower",
  },
  {
    'kode': 'I24160002',
    'nama': 'PT Laju Pasar Rimba',
    'narahubung': 'Sarah Sansa',
    'phone': '087356719563',
    'status': "Tidak",
    'alamat': {
      'street': 'Jalan Raya Sukabumi 53, Sukabumi, Jabar 127651',
    },
    'website' : "www.lajupasarrimba.com",
    'unitUsaha' : "Logistic",
  },
  {
    'kode': 'B04150085',
    'nama': 'PT Vera Sylva Kencana',
    'narahubung': 'Faris Shidqin',
    'phone': '082345678329',
    'status': "Ya",
    'alamat': {
      'street': 'Jalan Mawar 52, Ciamis, Jabar 762352',
    },
    'website' : "www.verasylvakencana.com",
    'unitUsaha' : "Broker",
  },
  {
    'kode': 'D24170034',
    'nama': 'PT Arena Hutan Lestari',
    'narahubung': 'Fauzan Syahril',
    'phone': '089675237812',
    'status': "Ya",
    'alamat': {
      'street': 'Jalan Sengked 65, Dramaga,Bogor, Jabar 16680',
    },
    'website' : "www.arenahutanlestari.com",
    'unitUsaha' : "Logistic",
  },
  {
    'kode': 'G64170006',
    'nama': 'CV Rindang Tretep',
    'narahubung': 'Berta Lanjar',
    'phone': '082387623478',
    'status': "Tidak",
    'alamat': {
      'street': 'Jalan Sentosa 76, Malang, Jatim, 765234',
    },
    'website' : "-",
    'unitUsaha' : "Grower",
  },
  {
    'kode': 'G54170087',
    'nama': 'CV Sultan Muda',
    'narahubung': 'Kevin Ardino',
    'phone': '089674356723',
    'status': "Ya",
    'alamat': {
      'street': 'Jalan Buruh 34, Magelang, Jateng, 675234',
    },
    'website' : "www.sultanmuda.com",
    'unitUsaha' : "Broker",
  },
  // {
  //   'kode': localStorage.gapoktanLahanID,
  //   'nama': localStorage.gapoktanLahanNamaPetani,
  //   'narahubung': 'Kevin Ardino',
  //   'phone': '089674356723',
  //   'status': "Ya",
  //   'alamat': {
  //     'street': 'Jalan Buruh 34, Magelang, Jateng, 675234',
  //   },
  //   'website' : "www.sultanmuda.com",
  //   'unitUsaha' : "Broker",
  // },
];

const getGapoktanById = (kode) => {
  return (kode === undefined) ? Items[0] : Items.find(x => x.kode === kode);
};

const getGapoktan = (limit) => {
  return (limit) ? Items.slice(0, limit) : Items;
};

export {
  Items,
  getGapoktan,
  getGapoktanById
};